import React from 'react';
import { entityRouteFor } from '../../utils/entity-route-for';

const labelForDraft = (entityType: string): string => {
  if (entityType === 'purchaseOrder') return 'Draft Purchase Order';
  if (entityType === 'salesOrder') return 'Draft Sales Order';
  return 'Draft';
};

export interface DraftChipProps {
  pluginId: string;
  entityType: string;
  entityId: string;
}

export const DraftChip: React.FC<DraftChipProps> = ({ pluginId, entityType, entityId }) => {
  const href = entityRouteFor({ pluginId, entityType, entityId });
  const inner = (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 8px', borderRadius: 12, background: '#eef2ff', color: '#4338ca', fontSize: 11 }}>
      📝 {labelForDraft(entityType)} — review
    </span>
  );
  return href ? (
    <a href={href} aria-label={`${labelForDraft(entityType)} ${entityId}`} style={{ textDecoration: 'none' }}>
      {inner}
    </a>
  ) : inner;
};
